import React from 'react';

import fetch from './../fetch';

import utils from './../../utils';

import {Tag} from 'antd';

const prefixUrL = 'academicGuidanceTeacherChooseResult/'

const columns = utils.columns([
    {
        key: '$index', 
        label: '序号'
    },
    // {
    //     key: 'state', 
    //     label: '状态', 
    //     render: (data) => {
    //         if (data === 1) {
    //             return <Tag color='blue'>待确认</Tag>
    //         } else if (data === 2) {
    //             return <Tag color='green'>已确认</Tag>
    //         } else {
    //             return <Tag>未知</Tag>
    //         }
    //     }
    // },
    {
        key: 'studentNo', 
        label: '学生学号', 
    },
    {
        key: 'studentName', 
        label: '学生姓名', 
    },
    {
        key: 'studentClassName', 
        label: '学生班级', 
    },
    {
        key: 'studentGrade', 
        label: '学生年级', 
    },
    {
        key: 'teacherCode',
        label: '教师工号'
    },
    {
        key: 'teacherName', 
        label: '教师姓名'
    },
    {
        key: 'teacherOrgName', 
        label: '教师所在部门', 
    },
    {
        key: 'termName', 
        label: '学期名称', 
    }
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post(`${prefixUrL}query?` + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    
};


export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    redirect
}